import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

/**
 * Reminder document interface
 */
export interface ReminderDocument extends BaseDocument {
  taskId: string
  reminderType: number // 0=Absolute, 1=Relative to due_date, 2=Relative to start_date, 3=Relative to created_on
  absoluteDate: number | null
  relativeOffsetMinutes: number | null
  notifyUserId: string
  notificationChannel: string
  isEnabled: boolean
  isSent: boolean
  sentAt: number | null
  recurrenceType: number | null
  recurrenceInterval: number | null
  recurrenceDaysOfWeek: number | null
  recurrenceDayOfMonth: number | null
  recurrenceEndDate: number | null
  recurrenceMaxOccurrences: number | null
  occurrenceCount: number
  lastSentAt: number | null
  nextScheduledAt: number | null
}

/**
 * Reminder-specific hooks
 */
const hooks = createEntityHooks<ReminderDocument>('reminders')

export const useReminders = (filter?: Partial<ReminderDocument>) => {
  const { data, isLoading, db } = hooks.useEntities(filter)
  return { reminders: data, isLoading, db }
}

export const useReminder = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { reminder: data, isLoading }
}

export const useReminderMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createReminder: create,
    updateReminder: update,
    deleteReminder: deleteEntity,
  }
}
